import { SystemConfigurationContext } from "context/systemConfigContext"
import PropTypes from "prop-types"
import React, { useContext, useState } from "react"
import { Modal, ModalBody } from "reactstrap"

const RejectModal = ({
  name,
  show,
  onRejectClick,
  onCloseClick,
  isCancel = false,
}) => {
  const { inputMax } = useContext(SystemConfigurationContext)
  const [remarks, setRemarks] = useState("")

  const handleRejectWithRemarks = () => {
    onRejectClick(remarks)
    setRemarks("")
  }
  const handleClose = () => {
    setRemarks("")
    onCloseClick()
  }
  const isRejectButtonDisabled = !remarks.trim()

  return (
    <Modal size="sm" isOpen={show} toggle={handleClose} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            onClick={handleClose}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <p className="text-muted font-size-16 mb-4">
            {!isCancel
              ? "Are you sure you want to reject the Order?"
              : "Are you sure you want to cancel the Order?"}
          </p>
          <textarea
            maxLength={inputMax}
            rows="3"
            className="form-control mb-3"
            placeholder="Add remarks..."
            value={remarks}
            onChange={e => setRemarks(e.target.value)}
          />

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleRejectWithRemarks}
              disabled={isRejectButtonDisabled}
            >
              {isCancel ? "Confirm" : "Reject"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

RejectModal.propTypes = {
  onCloseClick: PropTypes.func,
  onRejectClick: PropTypes.func,
  show: PropTypes.any,
}

export default RejectModal
